// Read intrinsic pixel dimensions of an image File via `createImageBitmap`.
// Decoding happens off the main thread in modern browsers (Chrome, Firefox,
// Safari 15+). The returned ImageBitmap is closed immediately to free the
// GPU/CPU memory it backed.

export type ImageDimensions = { width: number; height: number };

export async function readImageDimensions(file: File): Promise<ImageDimensions> {
  const bitmap = await createImageBitmap(file);
  const dims = { width: bitmap.width, height: bitmap.height };
  bitmap.close();
  return dims;
}
